import { MapPin, DollarSign } from "lucide-react";
import type { JobPosting } from "@applicant-reviewer/api";

interface JobCardProps {
  job: JobPosting;
  onSelect: (jobId: string) => void;
}

export default function JobCard({ job, onSelect }: JobCardProps) {
  const { compensation } = job;

  const payRange = compensation
    ? `$${compensation.min ?? ''}–$${compensation.max ?? ''} / ${compensation.type}`
    : null;

  return (
    <button
      type="button"
      onClick={() => onSelect(job.jobId)}
      className="w-full text-left bg-white rounded-2xl border border-gray-100 shadow-sm p-5 hover:border-blue-200 hover:shadow-md transition-all"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <h2 className="text-base font-bold text-gray-900 truncate">{job.title}</h2>
          <p className="text-sm font-medium text-gray-700 mt-0.5 truncate">{job.companyName}</p>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-2">
            {job.locationName && (
              <span className="flex items-center gap-1 text-xs text-gray-500">
                <MapPin className="w-3 h-3 flex-shrink-0" />
                {job.locationName}
              </span>
            )}
            {payRange && (
              <span className="flex items-center gap-1 text-xs text-gray-500">
                <DollarSign className="w-3 h-3 flex-shrink-0" />
                {payRange}
              </span>
            )}
          </div>
        </div>
        <span className="flex-shrink-0 text-xs font-semibold px-3 py-1 rounded-full bg-blue-50 text-blue-700">
          Apply
        </span>
      </div>
    </button>
  );
}
